import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do you provide part-time and full-time maids in Pune?",
    a: "Yes — we offer part-time, full-time and live-in maids across Pune. You can choose based on your daily routine, hours needed and budget. Our team will help you pick the right fit during booking.",
  },
  {
    q: "Are your maids verified?",
    a: "Absolutely. Every maid goes through ID verification, address proof, background screening and a hands-on skill check before we place them in your home. Your family's safety is non-negotiable.",
  },
  {
    q: "Do you provide live-in maids in Pune?",
    a: "Yes. We provide live-in maids, cooks, nannies and caretakers with proper accommodation understanding, off-days and clear expectations set upfront.",
  },
  {
    q: "Can I hire a babysitter or nanny through Quickmaid?",
    a: "Yes — we have trained babysitters and nannies for infant care, school-age children, feeding, hygiene and supervised activities. Full-time and part-time options available.",
  },
  {
    q: "Do you provide Japa Maids for post-delivery care?",
    a: "Yes. We provide specially trained Japa Maids for newborn care, mother's recovery, baby massage, hygiene and post-delivery support — usually placed within 24–72 hours.",
  },
  {
    q: "Which areas in Pune do you serve?",
    a: "Baner, Aundh, Kothrud, Wakad, Hinjewadi, Hadapsar, Viman Nagar, Magarpatta, Kondhwa, Kharadi, Koregaon Park, Pashan, Bavdhan, Nigdi, Balewadi, PCMC and more. If your area isn't listed — call us, we probably cover it.",
  },
  {
    q: "How do I book a maid?",
    a: "Tap 'Book Now' on any service card and fill in your details. You can also call us at +91 9309451659 or reach us on WhatsApp. Our team responds within minutes.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 md:py-32 bg-[var(--paper)]" data-testid="faq">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-12">
          <p className="label-caps text-[var(--gold)] mb-4">FAQ</p>
          <h2 className="font-display text-4xl md:text-5xl text-[var(--navy)] tracking-tight leading-[1.05]">
            Questions? We've got you covered.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rounded-3xl bg-white border border-slate-200 divide-y divide-slate-100 shadow-sm"
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-none px-6 md:px-8">
                <AccordionTrigger
                  className="text-left font-semibold text-[var(--navy)] text-base md:text-lg py-5 hover:no-underline"
                  data-testid={`faq-q-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
